import React, { useState, useEffect, Fragment, useRef } from 'react'
import { kebabCase } from 'lodash'
import { useMousePosition, useMouseUp } from '../../hooks'

import './ExpertComponentPanel.scss'

const ExpertComponentPanel = ({ addElement, data: { components }, getEditedAppBoundingClientRect }) => {
    const [tab, setTab] = useState(void 0)
    const [mouseUpEvt, setMouseUpEvt] = useState(void 0)

    const mousePosition = useMousePosition(20)
    useMouseUp(evt => setMouseUpEvt(evt))

    const componentsPanel = document.getElementById('editor-side-panel__right')

    // let dropZone = document.getElementById('iframe-dropzone')
    // if (!dropZone) {
    //     const wrapper = document.getElementById('id-product_iframe_cnt')
    //     dropZone = document.createElement('div')
    //     dropZone.setAttribute('id', 'iframe-dropzone')
    //     wrapper.appendChild(dropZone)
    // }
    // const updateDropZone = (show, data) => {
    //     if (show) {
    //         if (data) {
    //             // делаем размер чуть больше фактического чтобы скрыть лишние актефакты
    //             dropZone.style.width = data.w + 2 + 'px'
    //             dropZone.style.height = data.h + 2 + 'px'
    //             dropZone.style.left = data.x - 1 + 'px'
    //             dropZone.style.top = data.y - 1 + 'px'
    //         }
    //         dropZone.style.display = 'block'
    //     } else {
    //         dropZone.style.display = 'none'
    //     }
    // }

    return (
        <div className="expert-component-panel">
            {Object.entries(components).map(([key, datum]) =>
                tab === key ? (
                    <div key={key} className="expert-component-panel__components">
                        <ComponentContainer
                            name={key}
                            items={datum.items}
                            style={datum.style}
                            height={componentsPanel ? componentsPanel.offsetHeight - 41 - 40 : 0}
                        >
                            {items =>
                                items.map((item, i) => {
                                    const Element = elements[item.elementData.displayName]

                                    return (
                                        <Component
                                            key={i}
                                            name={key}
                                            data={item}
                                            addElement={addElement}
                                            mousePosition={mousePosition}
                                            mouseUpEvt={mouseUpEvt}
                                            getEditedAppBoundingClientRect={getEditedAppBoundingClientRect}
                                            // updateDropZone={updateDropZone}
                                        >
                                            {Element !== void 0 ? <Element elementData={item.elementData} /> : null}
                                        </Component>
                                    )
                                })
                            }
                        </ComponentContainer>
                    </div>
                ) : null,
            )}
            <div className="expert-component-panel__panel">
                {Object.entries(components).map(([key, datum]) => (
                    <div
                        key={key}
                        className={`expert-component-panel__tab ${
                            tab === key ? 'expert-component-panel__tab_active' : ''
                        }`}
                        onClick={() => setTab(tab === key ? void 0 : key)}
                    >
                        <img src={tab === key ? datum.iconHover : datum.icon} />
                    </div>
                ))}
            </div>
        </div>
    )
}

const ComponentContainer = ({ name, items, style, height, children }) => {
    const isTab = items.length && items.every(({ tab }) => tab !== void 0)

    const [tabIndex, setTabIndex] = useState(isTab ? 0 : void 0)

    const ref = useRef()

    const st = (isTab ? items[tabIndex].style : style) || {}
    const patchStyle = { ...st, ...(st.height ? { minHeight: st.height } : {}) }

    return (
        <>
            {isTab ? (
                <div className="expert-component-panel__components-tabs">
                    {items.map(({ tab, hint }, i) => (
                        <Fragment key={i}>
                            <div
                                className={`expert-component-panel__components-tab ${
                                    i === tabIndex ? 'expert-component-panel__components-tab_active' : ''
                                }`}
                                onClick={() => i !== tabIndex && setTabIndex(i)}
                            >
                                <span>{tab}</span>
                            </div>
                            {hint !== void 0 ? (
                                <div className="expert-component-panel__hint">
                                    <IconHint />
                                    <div className="expert-component-panel__hint-message">{hint}</div>
                                </div>
                            ) : null}
                        </Fragment>
                    ))}
                </div>
            ) : null}
            <div
                className="expert-component-panel__components-wrapper"
                style={{ maxHeight: `${height}px`, overflowY: 'overlay', overflowX: 'hidden', width: '280px' }}
            >
                <div
                    className={`expert-component-panel__${name}-components ${
                        isTab ? `expert-component-panel__${name}-components__${kebabCase(items[tabIndex].tab)}` : ''
                    }`}
                    style={patchStyle}
                    ref={ref}
                >
                    {isTab ? children(items[tabIndex].items) : children(items)}
                </div>
            </div>
        </>
    )
}

const Component = ({
    name,
    data,
    addElement,
    getEditedAppBoundingClientRect,
    mousePosition,
    mouseUpEvt,
    // updateDropZone,
    children,
}) => {
    const [draggableElementSizes, setDraggableElementSizes] = useState({
        width: 0,
        height: 0,
    })
    const [style, setStyle] = useState({})
    const [initialCoordinates, setInitialCoordinates] = useState([0, 0])
    const [dropArea, setDropArea] = useState(null)
    const [inDropArea, setInDropArea] = useState(false)
    const [isDraggable, setIsDraggable] = useState(false)

    const remixIframe = document.getElementById('remix-iframe')

    const blockIframe = () => {
        remixIframe.style.pointerEvents = 'none'
    }
    const unblockIframe = () => {
        remixIframe.style.pointerEvents = 'auto'
    }

    const getDropArea = async () => {
        const appBoundingClientRect = await getEditedAppBoundingClientRect()
        const iframeBoundingClientRect = remixIframe.getBoundingClientRect()

        let dropArea = {}
        const topOffset = 20
        const yDelta =
            iframeBoundingClientRect.top - (iframeBoundingClientRect.top + appBoundingClientRect.top - topOffset)

        dropArea.top = iframeBoundingClientRect.top + (appBoundingClientRect.top < 0 ? 0 : appBoundingClientRect.top)
        dropArea.left = iframeBoundingClientRect.width / 2 - appBoundingClientRect.width / 2
        dropArea.width = appBoundingClientRect.width

        if (appBoundingClientRect.height > iframeBoundingClientRect.height - topOffset) {
            if (yDelta <= topOffset) {
                dropArea.height = iframeBoundingClientRect.height - (topOffset - yDelta)
            } else {
                const bottomOffset =
                    appBoundingClientRect.height - (iframeBoundingClientRect.height + yDelta - topOffset)
                dropArea.height = iframeBoundingClientRect.height - (bottomOffset < 0 ? Math.abs(bottomOffset) : 0)
            }
        } else {
            dropArea.height = appBoundingClientRect.height
        }

        dropArea.xMin = dropArea.left
        dropArea.xMax = dropArea.left + dropArea.width
        dropArea.yMin = dropArea.top
        dropArea.yMax = dropArea.top + dropArea.height

        return dropArea
    }

    const onElementMouseDown = async evt => {
        evt.preventDefault()
        setIsDraggable(true)
        setInitialCoordinates([evt.clientX, evt.clientY])
        setDraggableElementSizes({
            width: evt.target.offsetWidth,
            height: evt.target.offsetHeight,
        })

        blockIframe()

        const _dropArea = await getDropArea()

        // updateDropZone(true, { w: _dropArea.width, h: _dropArea.height, x: _dropArea.left, y: _dropArea.top })

        setDropArea(_dropArea)
    }

    // useEffect(() => {
    //     if (isDraggable) {
    //         if (inDropArea) {
    //             updateDropZone(false)
    //         } else {
    //             updateDropZone(true)
    //         }
    //     } else {
    //         updateDropZone(false)
    //     }
    // }, [isDraggable, inDropArea])

    useEffect(() => {
        if (isDraggable) {
            setStyle({
                cursor: 'grabbing',
                position: 'fixed',
                zIndex: '9999999',
                left: `${mousePosition.x - draggableElementSizes.width / 2}px`,
                top: `${mousePosition.y - draggableElementSizes.height / 2}px`,
            })
            setInDropArea(
                dropArea
                    ? mousePosition.x >= dropArea.xMin &&
                          mousePosition.x <= dropArea.xMax &&
                          mousePosition.y >= dropArea.yMin &&
                          mousePosition.y <= dropArea.yMax
                    : false,
            )
        }
    }, [mousePosition])
    useEffect(() => {
        if (isDraggable) {
            async function run() {
                const onceClick =
                    mouseUpEvt.clientX === initialCoordinates[0] && mouseUpEvt.clientY === initialCoordinates[1]

                if (onceClick || inDropArea) {
                    const targetBoundingClientRect = mouseUpEvt.target.getBoundingClientRect()
                    const appBoundingClientRect = await getEditedAppBoundingClientRect()
                    const iframeBoundingClientRect = remixIframe.getBoundingClientRect()

                    const yDelta =
                        iframeBoundingClientRect.top - (iframeBoundingClientRect.top + appBoundingClientRect.top - 20)
                    const _dropArea = await getDropArea()

                    let centerX = 0
                    let centerY = 0

                    if (onceClick) {
                        centerX = _dropArea.width / 2
                        centerY = _dropArea.height / 2 + (yDelta > 20 ? yDelta - 20 : 0)
                    } else {
                        if (inDropArea) {
                            centerX = targetBoundingClientRect.left + draggableElementSizes.width / 2 - _dropArea.left
                            centerY =
                                targetBoundingClientRect.top +
                                draggableElementSizes.height / 2 -
                                _dropArea.top +
                                (yDelta > 20 ? yDelta - 20 : 0)
                        }
                    }
                    addElement(
                        Array.isArray(data.elementData)
                            ? data.elementData.map(item => ({
                                  ...item,
                                  centerX,
                                  centerY,
                              }))
                            : {
                                  ...data.elementData,
                                  centerX,
                                  centerY,
                              },
                    )
                }

                setDraggableElementSizes({
                    width: 0,
                    height: 0,
                })
                setStyle({})
                setInitialCoordinates([0, 0])
                setDropArea(null)
                setInDropArea(false)
                setIsDraggable(false)

                unblockIframe()
            }
            run()
        }
    }, [mouseUpEvt])

    return (
        <div
            className={`expert-component-panel__component-box expert-component-panel__${name}-component-box${
                isDraggable ? ' is-draggable' : ''
            }`}
            style={data.boxStyle}
        >
            <div onMouseDown={onElementMouseDown} style={style}>
                {isDraggable && !inDropArea ? (
                    <div className="expert-component-panel__wrong-box">
                        <IconWrong />
                    </div>
                ) : null}
                <div
                    className={`expert-component-panel__component expert-component-panel__${name}-component`}
                    style={data.componentStyle}
                >
                    {children}
                </div>
            </div>
        </div>
    )
}

const elements = {
    Text: ({ elementData }) => {
        const [text] = elementData.text.match(/[^<>]+(?=[<])/) || [elementData.text]

        return <pre>{text}</pre>
    },
}

const IconWrong = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icon-answer/wrong copy 12">
            <g id="Group 3">
                <path
                    id="Oval"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="white"
                />
                <g id="Group">
                    <path
                        id="Line 4"
                        d="M7 7L17 17"
                        stroke="#8E8E8E"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Line 4_2"
                        d="M17 7L7 17"
                        stroke="#8E8E8E"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </g>
    </svg>
)

const IconHint = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="5" r="4.5" fill="white" stroke="#2990FB" />
        <path
            d="M4.35547 6.25391C4.35547 5.88932 4.39974 5.59896 4.48828 5.38281C4.57682 5.16667 4.73828 4.95443 4.97266 4.74609C5.20964 4.53516 5.36719 4.36458 5.44531 4.23438C5.52344 4.10156 5.5625 3.96224 5.5625 3.81641C5.5625 3.3763 5.35938 3.15625 4.95312 3.15625C4.76042 3.15625 4.60547 3.21615 4.48828 3.33594C4.3737 3.45312 4.3138 3.61589 4.30859 3.82422H3.17578C3.18099 3.32682 3.34115 2.9375 3.65625 2.65625C3.97396 2.375 4.40625 2.23438 4.95312 2.23438C5.50521 2.23438 5.93359 2.36849 6.23828 2.63672C6.54297 2.90234 6.69531 3.27865 6.69531 3.76562C6.69531 3.98698 6.64583 4.19661 6.54688 4.39453C6.44792 4.58984 6.27474 4.80729 6.02734 5.04688L5.71094 5.34766C5.51302 5.53776 5.39974 5.76042 5.37109 6.01562L5.35547 6.25391H4.35547ZM4.24219 7.45312C4.24219 7.27865 4.30078 7.13542 4.41797 7.02344C4.53776 6.90885 4.6901 6.85156 4.875 6.85156C5.0599 6.85156 5.21094 6.90885 5.32812 7.02344C5.44792 7.13542 5.50781 7.27865 5.50781 7.45312C5.50781 7.625 5.44922 7.76693 5.33203 7.87891C5.21745 7.99089 5.0651 8.04688 4.875 8.04688C4.6849 8.04688 4.53125 7.99089 4.41406 7.87891C4.29948 7.76693 4.24219 7.625 4.24219 7.45312Z"
            fill="#2990FB"
        />
    </svg>
)

export default ExpertComponentPanel
